import { render, staticRenderFns } from "./approvalListManageRouter.vue?vue&type=template&id=5d031cbe&"
import script from "./approvalListManageRouter.vue?vue&type=script&lang=js&"
export * from "./approvalListManageRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports